// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"b9efa8e9","teamsContainer":"dea1737f","team":"c6e753ed","leftCol":"b3b456c8","teamName":"cc79f44d","id":"c59b879a"};